import {GetProducts} from './get-products';

const initGetProducts = () => {
  const getProducts = new GetProducts();
  getProducts.init();
};

export {initGetProducts};
